
import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

import { DataTestidDirective } from '@@shared/data-test-id-directive';

import { IconComponent } from '../icon/icon.component';
import { TagSeverity, TagSize } from './tag.model';
import { TagTestIds } from './tag-testids.model';

@Component({
	selector: 'sl-tag',
	templateUrl: './tag.component.html',
	styleUrl: './tag.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		IconComponent,
		DataTestidDirective,
	]
})
export class TagComponent {
	readonly label = input<string>();
	readonly severity = input<TagSeverity>(TagSeverity.Info);
	readonly size = input<TagSize>(TagSize.Regular);
	readonly icon = input<string>();

	readonly TagTestIds = TagTestIds;

	@HostBinding('class') get classes(): string {
		return `sl-tag sl-tag--${this.size()} sl-tag--${this.severity()}`;
	}
}
